import de from './de.js'

const translationsObject = {
    de: de
};



export default translationsObject